import {
    subscribeToNewsletter as subscribeToNewsletterFromService
} from '../../../services/api/newsletter';

import types from './types';

export const subscribeToNewsletter = () => async (dispatch) => {
    dispatch({
        type: types.SUBSCRIBE_TO_NEWSLETTER.REQUEST
    });

    try {
        await subscribeToNewsletterFromService();
        dispatch({
            type: types.SUBSCRIBE_TO_NEWSLETTER.SUCCESS
        });
    }
    catch (e) {
        dispatch({
            type: types.SUBSCRIBE_TO_NEWSLETTER.ERROR
        });
    }
};

// TODO Get rid of thunk here
export const updateNewsletterError = () => (dispatch) => {
    dispatch({
        type: types.UPDATE_NEWSLETTER_ERROR,
        payload: false
    });
};
